<template>
    <div>
      <CRow>
        <CCol xs="12" sm="12" md="12" lg="4" xl="3">
          <CCard>
            <CCardHeader class="d-flex justify-content-between">
              <b><i class="fas fa-calendar"></i>&nbsp;Facturación</b>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs="12" sm="6" md="6" lg="12" v-if="$store.getters.get_rol.id !== 7">
                <CSelect
                  label="Sede: "
                  :value.sync="campu_id"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="handleCampusChange"
                />
              </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Desde" type="date" aria-label="shift_date" @input="mtd_data" size="sm" id="init"
                    v-model="filter.init" />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Hasta" type="date" aria-label="shift_date" @input="mtd_data" id="end" size="sm"
                    v-model="filter.end" />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Total de Comprobantes" type="text" size="sm" v-model="totalComprobantes" disabled />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <button
                    class="btn btn-sm btn-success text-white w-100"
                    @click="mtdSyncroSunat"
                  >
                    <i class="fas fa-spinner" aria-hidden="true"></i> Sincronizar
                  </button>
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12" class="mt-2">
                  <button
                    class="btn btn-sm btn-danger text-white w-100"
                    @click="mtdDownloadAllVouchers"
                    :disabled="isDownloading"
                  >
                    <i class="fas fa-file-archive" aria-hidden="true"></i> 
                    {{ isDownloading ? `Descargando ${downloadProgress}/${totalComprobantes}...` : 'Descargar Comprobantes' }}
                  </button>
                </CCol>
                <!-- <div class="col-md-3 col-lg-3 col-sm-3 col-xs-3 mt-3">
                    <button
                      type="button"
                      class="btn text-white btn-sm bg-main w-100"
                      @click="mtdSyncroSunat"
                    >
                      <i class="fas fa-syncro"></i> Útima sincro:
                      {{ lastUpdate }}
                    </button>
                  </div> -->
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs="12" sm="12" md="12" lg="8" xl="9">
          <CTableWrapper 
            :items="data" 
            :fields="fields" 
            hover 
            :striped="true" 
            :border="true" 
            small 
            fixed
            billing
            caption="Lista de Comprobantes" 
            icon="fas fa-coins" 
            @mtdBack="mtdBack" 
            @mtdReport="mtdReport"
            :size="'md'" 
            :actions="true" 
            :myButtons="myButtons" 
            @mtd_voucher="mtd_voucher" 
            @mtd_status_sunat = "mtd_status_sunat"
            @mtd_nc_sunat = "mtd_nc_sunat"
            :withActions="'2%'"
          />
        </CCol>
      </CRow>
      <cModalSunatVue
      :title="modalSunat.title"
      :boo_modal="modalSunat.modal_form"
      :item="modalSunat.item"
      :garantias="modalSunat.garantias"
      :doc="modalSunat.doc"
      @closeModalSunat="closeModalSunat"
    ></cModalSunatVue>
  
    </div>
    
  </template>
  
  <script>
  const fields = [
    { key: "index", label: "Id", _style: "width:1%" },
    { key: "campu_name", label: "Sede", _style: "width:10%;" },
    { key: "client", label: "Cliente", _style: "width:10%;" },
    { key: "payment_condition", label: "Método de pago", _style: "width:5%;" },
    /* { key: "user", label: "Personal", _style: "width:10%;" }, */
    { key: "date_formatted", label: "Fecha Emisión", _style: "width:10%;" },
    { key: "serie", label: "Serie", _style: "width:10%;" },
    { key: "number", label: "Correlativo", _style: "width:10%;" },
    /* { key: "products", label: "Productos", _style: "width:15%;" }, */
    { key: "subtotal", label: "Subtotal", _style: "width:10%;" },
    { key: "discount_amount", label: "Descuento", _style: "width:10%;" },
    { key: "all_total", label: "Total", _style: "width:10%;" },
    { key: "status", label: "Estado", _style: "width:5%;" },
  ];
  
  import CTableWrapper from "../../../components/shared/datatable/Table.vue";
  import { mapActions } from "vuex";
  import moment from "moment";
  import cModalSunatVue from "./modals/cModalSunatVue.vue";

  export default {
    components: {
      CTableWrapper,
      cModalSunatVue
    },
    data() {
      return {
        prefix: "billing",
        fields,
        data: [],
        excel: [],
        totalComprobantes: 0,
        dataBarbers: [],
        filter: {
          init: null,
          end: null,
        },
  
        labelIcon: {
          labelOn: "\u2713",
          labelOff: "\u2715",
        },
        componentKey: 0,
        data_campus: [],
        campu_id: 0,
        myButtons: [
          {
            class: "btn-sm",
            color: "danger",
            tooltip: "Comprobante",
            action: "mtd_voucher",
            icon: "fas fa-file-pdf",
          },
          {
            class: "btn-sm",
            color: "info",
            tooltip: "Estado Sunat",
            action: "mtd_status_sunat",
            icon: "fa fa-eye",
          },
          {
            class: "btn-sm",
            color: "warning",
            tooltip: "Nota de Crédito",
            action: "mtd_nc_sunat",
            icon: "fa fa-recycle",
          },
          {
            class: "btn-sm",
            color: "warning",
            tooltip: "Nota de Crédito",
            action: "mtd_nc_sunat",
            icon: "fa fa-recycle",
            show: {
              value: "is_state",
            },
          },
        ],
        modalSunat: {
          title: "",
          modal_form: false,
          item:{}
        },
        data_type_notes: [], // Para almacenar los tipos de nota de credito
        isDownloading: false,
        downloadProgress: 0,
      };
    },
    computed: {
      cpStatus: function () {
        if (this.companies.state == 1) return true;
        return false;
      },
    },
    created() {
      this.getCampus();
      this.getTypeNotes();
      moment.locale("es");
      this.filter.end = moment().format("YYYY-MM-DD");
      this.filter.init = this.filter.end;
      this.mtd_data();
    },
    methods: {
      ...mapActions(["get", "post"]),
      handleCampusChange() {
        this.mtd_data();
      },
      mtd_data() {
        if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Por favor, selecciona un rango de fechas válido.',
          });
        }
        this.post({
          url: this.$store.getters.get__url + "/" + this.prefix,
          token: this.$store.getters.get__token,
          params: {
            init: this.filter.init,
            end: this.filter.end,
            campu_id: this.campu_id,
            company_id: this.$store.getters.get_company.id,
          },
        })
          .then((response) => {
            this.data = response.data;
            this.totalComprobantes = this.data.length;
            this.excel=[];
            let index = 1;
            this.data.forEach((item) => {
              let sunatObj = typeof item.sunat === 'string' ? JSON.parse(item.sunat) : item.sunat;
              let invoiceObj = typeof item.invoice === 'string' ? JSON.parse(item.invoice) : item.invoice;
              
              item.index = index++;
              item.campu_name = item.campu.name;
              item.campu = item.campu_id ? item.campu.name : '-';
              item.client = item.sale.client_id ? item.sale.client.name : 'Cliente varios';
              item.payment_condition = item?.sale?.method_payment.name || 'No especificado';
              item.date_formatted = moment(invoiceObj?.invoice?.fechaEmision).format("DD/MM/YYYY") || 'No especificado';
              item.serie = item?.serie ? item?.serie : '-';
              item.number = item?.number ? item?.number.toString().slice(-8).padStart(8, '0') : '-';
              item.subtotal = parseFloat(item?.sale?.total || 0).toFixed(2);
              item.discount_amount = item?.sale?.ajustement_amount ? parseFloat(item?.sale?.ajustement_amount).toFixed(2) : '0.00';
              item.all_total = parseFloat(item?.sale?.total_payment || 0).toFixed(2);
              /* item.all_total = item.total_con_descuento = (
                parseFloat(item?.sale?.total || 0) -
                parseFloat(item?.sale?.ajustement_amount || 0)
              ).toFixed(2); */
              /* switch (sunatObj?.json?.message_code) {
                case 0:
                  item.status = sunatObj?.json?.state_sunat || "Sin estado";
                  break;
                default:
                  item.status = sunatObj?.json?.message || "Sin estado";
              } */
              item.status = sunatObj?.json?.state_sunat || "Sin estado";
              this.excel.push({
                'date':moment(invoiceObj?.invoice?.fechaEmision).format("DD/MM/YYYY") || 'No especificado' ,
                'sede': item.campu_name || '-',
                'tipo_pago':invoiceObj?.invoice?.tipoComprobante,
                'serie': item?.serie ? item?.serie : '-',
                'numero_pago':item?.number ? item?.number.toString().slice(-8).padStart(8, '0') : '-',
                //'tipo_cliente': 6,
                'tipo_cliente': item.sale.client_id
                  ? (item.sale.client.document && item.sale.client.document.length === 8
                      ? 1
                      : item.sale.client.document && item.sale.client.document.length === 11
                        ? 6
                        : '-')
                  : '',
                'dni':item.sale.client_id ? item.sale.client.document : 'No Registrado',
                'cliente':item.sale.client_id ? item.sale.client.name : 'Cliente varios',
                'gravada':parseFloat(invoiceObj?.invoice?.totalGravada || 0).toFixed(2),
                'igv':parseFloat(invoiceObj?.invoice?.totalIgv || 0).toFixed(2),
                'total':parseFloat(invoiceObj?.invoice?.total|| 0).toFixed(2),
                'cambio': "1.000"
              })
              
            });
          })
          .catch((errors) => {
            Swal.fire({
              title: errors,
              icon: "error",
            });
          });
      },
      getCampus() {
        this.data_campus = [];
        this.get({
          url:
            this.$store.getters.get__url +
            "/users/bycampus/" +
            this.$store.getters.get_company.id,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.statusCode == 200 && Array.isArray(response.data)) {
            this.data_campus.push({
              label: "Todos",
              value: 0,
            });

            response.data.forEach((element) => {
              this.data_campus.push({
                label: element.name,
                value: element.id,
              });
            });
          }
        });
      },
      mtd_voucher(item) {
        let sunatObj = typeof item.sunat === 'string' ? JSON.parse(item.sunat) : item.sunat;
        window.open(sunatObj?.json?.enlace_del_pdf_ticket, "_blank");
      },
      mtdSyncroSunat: async function () {
        await this.get({
          url:
            this.$store.getters.get__url +
            "/billing/syncroSunat/" +
            this.$store.getters.get_company.id,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            this.mtd_data();
          })
          .catch((errors) => {});
      },
      mtdBack: function () {
        this.$emit("mtdBack");
      },
     mtdReport: async function() {
        try {
          const ExcelJS = require('exceljs');
          const { saveAs } = require('file-saver');
          
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet("Reporte");

  
          worksheet.mergeCells('A1:A2'); 
          worksheet.mergeCells('B1:B2'); 
          worksheet.mergeCells('C1:C2'); 
          worksheet.mergeCells('D1:F1'); 
          worksheet.mergeCells('G1:I1'); 
          worksheet.mergeCells('J1:L1'); 
          worksheet.mergeCells('M1:M2'); 
          worksheet.mergeCells('N1:N2'); 
          worksheet.mergeCells('O1:O2'); 
          worksheet.mergeCells('P1:P2'); 
          worksheet.mergeCells('Q1:Q2'); 
          worksheet.mergeCells('R1:U1'); 
          worksheet.mergeCells('V1:V2');

          worksheet.getCell('A1').value = "NUMERO CORRELATIVO DEL REGISTRO CODIGO UNICO DE LA OPERACIÓN";
          worksheet.getCell('B1').value = "FECHA DE EMISION DE COMPROBANTE DE PAGO O DOCUMENTO";
          worksheet.getCell('C1').value = "SEDE";
          worksheet.getCell('D1').value = "COMPROBANTE DE PAGO O DOCUMENTO";
          worksheet.getCell('G1').value = "INFORMACIÓN DEL CLIENTE";
          worksheet.getCell('J1').value = "BASE";
          worksheet.getCell('M1').value = "IGV Y/O IPM";
          worksheet.getCell('N1').value = "IMPUESTO AL CONSUMO DE LAS BOLSAS DE PLÁSTICO";
          worksheet.getCell('O1').value = "OTROS TRIBUTOS Y CARGOS";
          worksheet.getCell('P1').value = "IMPORTE TOTAL DEL COMPROBANTE DE PAGO";
          worksheet.getCell('Q1').value = "TIPO DE CAMBIO";
          worksheet.getCell('U1').value = "REFERENCIA DEL COMPROBANTE DE PAGO O DOCUMENTO ORIGINAL QUE SE MODIFICA";
          worksheet.getCell('V1').value = "TXT SUNAT";


          worksheet.getCell('D2').value = "TIPO";
          worksheet.getCell('E2').value = "SERIE";
          worksheet.getCell('F2').value = "NÚMERO";
          worksheet.getCell('G2').value = "TIPO";
          worksheet.getCell('H2').value = "NUMERO";
          worksheet.getCell('I2').value = "APELLIDOS Y NOMBRES, DENOMINACIÓN O RAZÓN SOCIAL";
          worksheet.getCell('J2').value = "OPERACION GRAVADA";
          worksheet.getCell('K2').value = "EXONERADA";
          worksheet.getCell('L2').value = "INAFECTA";
          worksheet.getCell('R2').value = "FECHA";
          worksheet.getCell('S2').value = "TIPO";
          worksheet.getCell('T2').value = "SERIE";
          worksheet.getCell('U2').value = "NUMERO";


          const headerCells = ['A1', 'B1', 'C1', 'F1', 'I1', 'L1', 'L2', 'M1', 'N1', 'O1', 'P1', 'Q1', 'U1', 'V1',
                              'C2', 'D2', 'E2', 'F2', 'G2', 'H2', 'I2', 'J2', 'K2', 'Q2', 'R2', 'S2', 'T2', 'U2'];
          
          headerCells.forEach(cell => {
            const cellObj = worksheet.getCell(cell);
            cellObj.font = { bold: true };
            cellObj.alignment = { horizontal: "center", vertical: "center", wrapText: true };
            cellObj.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "D9E1F2" }
            };
            cellObj.border = {
              top: { style: "thin" }, left: { style: "thin" },
              bottom: { style: "thin" }, right: { style: "thin" }
            };
          });

   
        
          this.excel.forEach(item => {
            const row = worksheet.addRow([
              item['correlativo']|| "", 
              item['date'], 
              item['sede'],
              item['tipo_pago'], 
              item['serie'],
              item['numero_pago'],
              item['tipo_cliente'], 
              item['dni'], 
              item['cliente'], 
              parseFloat(item['gravada'] || 0), 
              parseFloat(item['exonerada'] || 0), 
              parseFloat(item['inafecta'] || 0), 
              parseFloat(item['igv'] || 0), 
              parseFloat(item['impuesto_bolsas'] || 0), 
              parseFloat(item['otros_tributos'] || 0), 
              parseFloat(item['total'] || 0), 
              item['cambio'], 
              item['ref_fecha'] || "", 
              item['ref_tipo'] || "", 
              item['ref_serie'] || "", 
              item['ref_numero'] || "", 
              item['txt_sunat'] || "" 
            ]);

            
            ['I', 'J', 'K', 'L', 'M', 'N', 'O'].forEach(col => {
              const cell = row.getCell(col);
              cell.numFmt = '#,##0.00';
            });


            row.eachCell((cell) => {
              cell.border = {
                top: { style: "thin" }, left: { style: "thin" },
                bottom: { style: "thin" }, right: { style: "thin" }
              };
            });
          });

     
          const lastRow = worksheet.rowCount;
          worksheet.mergeCells(`A${lastRow+1}:I${lastRow+1}`);
          const totalLabelCell = worksheet.getCell(`A${lastRow+1}`);
          totalLabelCell.value = "TOTALES";
          totalLabelCell.font = { bold: true };
          totalLabelCell.alignment = { horizontal: "right" };

     
          const sumColumns = ['J', 'K', 'L', 'M', 'N', 'O', 'P'];
          sumColumns.forEach(col => {
            const cell = worksheet.getCell(`${col}${lastRow+1}`);
            cell.value = {
              formula: `SUM(${col}3:${col}${lastRow})`,
              date1904: false
            };
            cell.numFmt = '#,##0.00';
            cell.font = { bold: true };
            cell.border = {
              top: { style: "thin" }, left: { style: "thin" },
              bottom: { style: "thin" }, right: { style: "thin" }
            };
          });

          worksheet.columns = [
            { width: 10 },  
            { width: 10 },  
            { width: 12 },  
            { width: 8 },   
            { width: 8 },   
            { width: 10 },  
            { width: 8 },   
            { width: 15 },  
            { width: 40 },  
            { width: 12 },  
            { width: 12 },  
            { width: 12 },  
            { width: 12 }, 
            { width: 15 },  
            { width: 15 },  
            { width: 15 },  
            { width: 12 },  
            { width: 12 }, 
            { width: 8 },   
            { width: 8 },   
            { width: 10 },  
            { width: 15 }   
          ];

          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], { 
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
          });
          saveAs(blob, "Reporte_Comprobantes_Completo.xlsx");
          
        } catch (error) {
          console.error("Error al generar reporte:", error);
          Swal.fire({
            title: "Error al generar el reporte",
            text: error.message,
            icon: "error"
          });
        }
      },
      mtd_status_sunat(item){
        let sunatObj = typeof item.sunat === 'string' ? JSON.parse(item.sunat) : item.sunat;
         console.log(sunatObj);
         this.modalSunat= {
          title: "DOCUMENTOS SUNAT",
          modal_form: true,
          item: sunatObj 
        }
      },
      getTypeNotes() {
        this.get({
          url: this.$store.getters.get__url + "/" + this.prefix + "/typeNotes",
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.statusCode == 200 && Array.isArray(response.data)) {
            this.data_type_notes = response.data;
          }
        }).catch((error) => {
          console.error("Error al cargar tipos:", error);
        });
      },
      mtd_nc_sunat(item) {
        console.log(item);

        // Genera las opciones del select dinámicamente
        const typeOptions = this.data_type_notes.map(type => 
          `<option value="${type.id}">${type.name.length > 40 ? type.name.substring(0, 40) + '...' : type.name}</option>`
        ).join('');

        Swal.fire({
          title: "Emitir Nota de Crédito",
          html: `
                <div class="text-start">
                  <div class="mb-3">
                    <label for="motive_select" class="form-label"><strong>Tipo de motivo:</strong></label>
                    <select id="motive_select" class="form-control">
                      <option value="">-- Seleccione un motivo --</option>
                      ${typeOptions}
                    </select>
                  </div>
                  <div class="mb-3">
                    <label for="motive_cancel" class="form-label"><strong>Descripción del motivo:</strong></label>
                    <textarea id="motive_cancel" class="form-control text-uppercase" rows="3" placeholder="Ingrese el motivo detallado">${item.motive_cancel || ''}</textarea>
                  </div>
                </div>
                `,
          icon: "warning",
          showDenyButton: true,
          confirmButtonColor: "#2eb85c",
          denyButtonColor: "#6c757d",
          confirmButtonText: "Emitir",
          denyButtonText: "Cerrar",
          preConfirm: () => {
            const motiveSelect = document.getElementById('motive_select').value;
            const motiveText = document.getElementById('motive_cancel').value;
            
            if (!motiveSelect) {
              Swal.showValidationMessage('Debe seleccionar un tipo de nota de crédito');
              return false;
            }
            
            if (!motiveText.trim()) {
              Swal.showValidationMessage('Debe ingresar un motivo');
              return false;
            }
            
            return { motiveSelect, motiveText };
          }
        }).then((result) => {
          if (result.isConfirmed) {

            const { motiveSelect, motiveText } = result.value;
      
            const params = {
              id: item.id, // voucher
              company_id: this.$store.getters.get_company.id,
              campu_id: this.$store.getters.get_campu.id,
              user_id: this.$store.getters.get__user_id,
              type_id: motiveSelect, // ID del motivo seleccionado
              motive: motiveText, // Descripción del motivo
              products: item.sale.detail
            };

            this.post({
              url: `${this.$store.getters.get__url}/${this.prefix}/creditNote`,
              token: this.$store.getters.get__token,
              params: params,
            })
              .then((response) => {
                if (response.data.state == 1) {
                  Swal.fire({
                    title: "Éxito",
                    text: "Nota de crédito creada.",
                    icon: "success",
                  });
                  this.mtd_data();
                }
              })
              .catch((error) => {
                Swal.fire({
                  title: "Error",
                  text: "Ocurrió un error al procesar la solicitud.",
                  icon: "error",
                });
                console.error("Error en updateState:", error);
              });
          }
        });
      },
      closeModalSunat(){
        this.modalSunat= {
          title: "",
          modal_form: false,
          item:{}
        }
      },

      async mtdDownloadAllVouchers() {
      if (!this.data || this.data.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Sin comprobantes',
          text: 'No hay comprobantes para descargar en el rango seleccionado.',
        });
        return;
      }

      // Confirmar descarga
      const confirm = await Swal.fire({
        icon: 'question',
        title: '¿Descargar comprobantes?',
        text: `Se descargarán ${this.data.length} comprobantes en un archivo ZIP.`,
        showCancelButton: true,
        confirmButtonText: 'Descargar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#2eb85c',
      });

      if (!confirm.isConfirmed) return;

      this.isDownloading = true;
      this.downloadProgress = 0;

      try {
        const JSZip = require('jszip');
        const { saveAs } = require('file-saver');
        const zip = new JSZip();

        const folder = zip.folder(`Comprobantes_${this.filter.init}_${this.filter.end}`);
        const errors = [];

        for (let i = 0; i < this.data.length; i++) {
          const item = this.data[i];
          
          try {
            let sunatObj = typeof item.sunat === 'string' ? JSON.parse(item.sunat) : item.sunat;
            const pdfUrl = sunatObj?.json?.enlace_del_pdf_ticket;

            if (!pdfUrl) {
              errors.push(`${item.serie}-${item.number}: URL no disponible`);
              this.downloadProgress++;
              continue;
            }

            // Descargar el PDF usando proxy del backend para evitar CORS
            const proxyUrl = `${this.$store.getters.get__url}/billing/downloadPdf?url=${encodeURIComponent(pdfUrl)}`;
            const response = await fetch(proxyUrl, {
              headers: { 'Authorization': `Bearer ${this.$store.getters.get__token}` }
            });
            
            if (!response.ok) {
              let errorDetail = `HTTP ${response.status}`;
              try {
                const rawText = await response.text();
                // Intentar parsear como JSON primero
                try {
                  const errJson = JSON.parse(rawText);
                  errorDetail = errJson.error || errJson.message || errorDetail;
                } catch (_) {
                  // Si no es JSON, tomar los primeros 200 chars del HTML/texto
                  errorDetail = `HTTP ${response.status}: ${rawText.replace(/<[^>]+>/g, '').substring(0, 200).trim()}`;
                }
              } catch (_) {}
              console.error(`[PDF Error] ${item.serie}-${item.number}:`, errorDetail);
              errors.push(`${item.serie}-${item.number}: ${errorDetail}`);
              this.downloadProgress++;
              continue;
            }

            const contentType = response.headers.get('Content-Type') || '';
            if (!contentType.includes('pdf') && !contentType.includes('octet-stream')) {
              errors.push(`${item.serie}-${item.number}: Respuesta inesperada (${contentType})`);
              this.downloadProgress++;
              continue;
            }

            const blob = await response.blob();
            const fileName = `${item.serie}-${item.number}_${item.date_formatted.replace(/\//g, '-')}.pdf`;
            
            folder.file(fileName, blob);
            
          } catch (err) {
            errors.push(`${item.serie}-${item.number}: ${err.message}`);
          }

          this.downloadProgress++;
        }

        // Generar y descargar el ZIP
        const zipBlob = await zip.generateAsync({ 
          type: 'blob',
          compression: 'DEFLATE',
          compressionOptions: { level: 6 }
        });

        saveAs(zipBlob, `Comprobantes_${this.filter.init}_${this.filter.end}.zip`);

        // Mostrar resumen
        if (errors.length > 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Descarga completada con errores',
            html: `
              <p>Se descargaron <b>${this.data.length - errors.length}</b> de <b>${this.data.length}</b> comprobantes.</p>
              <p><b>Errores:</b></p>
              <ul class="text-start" style="max-height: 200px; overflow-y: auto;">
                ${errors.map(e => `<li>${e}</li>`).join('')}
              </ul>
            `,
          });
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Descarga completada',
            text: `Se descargaron ${this.data.length} comprobantes correctamente.`,
            timer: 3000,
          });
        }

      } catch (error) {
        console.error('Error al generar ZIP:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al generar el archivo ZIP.',
        });
      } finally {
        this.isDownloading = false;
        this.downloadProgress = 0;
      }
    },
    },
  
  };
  </script>
  
  <style lang="scss" scoped></style>